import React from "react";
import Banner from "../../Section/Home/Banner/banner";
import Desktop from "../../Media/Investment_Desktop.webp";
import Mobile from "../../Media/Investemnt_Mobile.webp";
import About from "../../Section/Detail/about/about";
import Promo from "../../Section/Home/Promo/promo";
import Lokasi from "../../Section/Home/Lokasi/lokasi";
import Produk from "../Investment/investment1/investment1";

import investment from "./investment.json";

const poininvestment = [
  "Siap Huni",
  "Free DP",
  "Voucher Cashback Up To 270",
  "Free AC",
  "Easy Access",
  "High Potential Captive Market",
  "Surrounded by Many Residential",
];
const Investment = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About
        poin={investment.point}
        judul={investment.judul}
        Deskrisi={investment.deskripsi}
      />
      <Promo poininvestment={poininvestment} />
      <Produk />
      <Lokasi />
    </div>
  );
};

export default Investment;
